import { useState, useRef, useEffect, Fragment, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ArrowRightStartOnRectangleIcon,
  UserIcon,
} from '@heroicons/react/24/solid';
import { Transition } from '@headlessui/react';
import Avatar from '../Profile/elements/Avatar';
import TokenService from '../../services/token.service';
import ConfirmationModal from '../modals/ConfirmationModal/ConfirmationModal';
import { UserContext } from '../../utils/contexts/UserContext';

export default function ProfileDropdown({ userData }) {
  const [open, setOpen] = useState(false);
  const [isLogoutModalOpen, setLogoutModalOpen] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();
  const { setUser, isStudent, isUniversity, isAdmin } = useContext(UserContext);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const promptSignOut = () => {
    setOpen(false);
    setLogoutModalOpen(true);
  };

  const confirmSignOut = () => {
    TokenService.removeTokens();
    setUser(null);
    console.log('Signing out...');
    setLogoutModalOpen(false);
    navigate('/login');
  };

  const menuItems = [
    ...(!isAdmin ? [{
      text: isStudent ? 'Portfolio' : isUniversity ? 'Dashboard' : 'Profile',
      icon: <UserIcon className="size-4 fill-gray-500 dark:fill-white/60" />,
      onClick: () => navigate(isStudent ? '/portfolio' : isUniversity ? '/organization/dashboard' : '/profile'),
      className: 'dark:text-white',
    }] : []),
    // {
    //   text: 'Settings',
    //   icon: (
    //     <Cog6ToothIcon className="size-4 fill-gray-500 dark:fill-white/60" />
    //   ),
    //   onClick: () => navigate('/settings'),
    //   className: 'dark:text-white',
    // },
    {
      text: 'Sign Out',
      icon: <ArrowRightStartOnRectangleIcon className="w-4 h-4" />,
      onClick: promptSignOut,
      className:
        'text-red-600 dark:text-red-500 hover:text-red-700 dark:hover:text-red-400',
    },
  ];

  return (
    <>
      <div className="relative flex justify-center" ref={ref}>
        <div className="flex items-center justify-center">
          <button onClick={() => setOpen(!open)}>
            <Avatar
              name={userData?.first_name}
              profileImage={userData?.avatar_url || userData?.avatar || userData?.profileImage}
              className="w-7 h-7 text-xs"
              onClick={() => setOpen(!open)}
            />
          </button>
        </div>

        <Transition
          as={Fragment}
          show={open}
          enter="transition ease-out duration-150"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          <div className="absolute top-12 right-0 w-52 rounded-xl border border-gray-600 dark:border-gray-700 bg-white/80 dark:bg-gray-900/70 backdrop-blur-sm p-1 text-sm shadow-lg z-50 origin-top-right">
            {menuItems.map(({ text, icon, onClick, className = '' }) => (
              <button
                key={text}
                onClick={onClick}
                className={`flex w-full items-center gap-2 rounded-lg px-3 py-1.5 text-gray-700 hover:bg-gray-200  dark:hover:bg-gray-800 ${className}`}
              >
                {icon}
                {text}
              </button>
            ))}
          </div>
        </Transition>
      </div>
      <ConfirmationModal
        isOpen={isLogoutModalOpen}
        onClose={() => setLogoutModalOpen(false)}
        onConfirm={confirmSignOut}
        title="Confirm Sign Out"
        message="Are you sure you want to sign out?"
        confirmText="Sign Out"
        confirmButtonVariant="error"
      />
    </>
  );
}
